import dynamic from 'next/dynamic'
import { memo } from 'react'
import classNames from 'classnames'

const Image = dynamic(() => import('@dustin-web/microsite-components/src/image/image'))

import './carousel-pagination.scss'

type Props = {
  imageUrl: string
  isSmallScreen: boolean
  isActive: boolean
  showCountOverlay: boolean
  overlayCount: number
  width: number
  height: number
  index: number
  setShowModal: () => void
} & React.HTMLAttributes<HTMLSpanElement>

const CarouselPagination = ({
  imageUrl,
  isActive,
  isSmallScreen,
  showCountOverlay,
  overlayCount,
  width,
  height,
  index,
  onClick,
  setShowModal,
}: Props) => {
  if (isSmallScreen) {
    return (
      <button
        data-testid={`carousel-pagination-item-mobile-${index}`}
        onClick={onClick}
        className={classNames('carousel-pagination__item--mobile', { active: isActive })}
      />
    )
  }

  const onButtonClick = (event: React.MouseEvent<HTMLSpanElement>) => {
    onClick?.(event)

    if (showCountOverlay) {
      setShowModal()
    }
  }

  return (
    <button
      data-testid={`carousel-pagination-item-${index}`}
      onClick={onButtonClick}
      className={classNames('carousel-pagination__item', { active: isActive })}>
      {showCountOverlay && (
        <span
          data-testid="carousel-pagination-count-overlay"
          className="carousel-pagination__count-overlay">
          +{overlayCount}
        </span>
      )}
      <Image
        draggable={false}
        width={width}
        height={height}
        src={imageUrl}
        alt={`Product Image ${index + 1}`}
      />
    </button>
  )
}

export default memo(CarouselPagination)
